import React, { useEffect, useState } from 'react';
import { FriendData, FriendsContext } from './friends-context';
import { API_BASE } from '@/config.ts';
import { toast } from 'sonner';
import { FriendRequest } from '@/models/friend-request.ts';

// TODO: refetch friends on change account. NOW its bug - showing exited account's friends in new account after logout/login (clear cookies)
export const FriendsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [friends, setFriends] = useState<FriendData[]>([]);
  const [pendingRequests, setPendingRequests] = useState<FriendRequest[]>([]);


  useEffect(() => {
    const fetchFriends = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/friends`, {
          credentials: 'include',
        });
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        setFriends(data);
      } catch (err) {
        console.error('Failed to fetch friends:', err);
      }
    };

    // TODO: call it, untested, not updated in API
    const fetchFriendRequests = async () => {
      try {
        fetch(`${API_BASE}/api/friends/requests`, { credentials: 'include' })
          .then((res) => res.json())
          .then((data) => setPendingRequests(data.requests));
      } catch (err) {
        console.error('Failed to fetch friend requests:', err);
      }
    };

    fetchFriends();
  }, []);

  const toggleFriend = async (id: string) => {
    const alreadyFriend = friends.some((f) => f.id === id);

    if (alreadyFriend) {
      await fetch(`${API_BASE}/api/friends/${id}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      toast.success(`Друг удален!`);
      setFriends((prev) => prev.filter((f) => f.id !== id));
    } else {
      await fetch(`${API_BASE}/api/friends`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: id }),
      });
      toast.success(`Друг добавлен!`);
      setFriends((prev) => [...prev, { id }]);
    }
  };

  const isFriend = (id: string) =>friends.some((f) => f.id === id);

  return (
    <FriendsContext.Provider value={{ friends, setFriends, pendingRequests, toggleFriend, isFriend }}>
      {children}
    </FriendsContext.Provider>
  );
};
